import { useState } from 'react';
import { X, Lightbulb, MousePointer2, Link2, Eye, Sparkles } from 'lucide-react';

const TutorialOverlay = ({ isOpen, onComplete }) => {
  const [dismissed, setDismissed] = useState(false);

  if (!isOpen || dismissed) return null;

  const handleDismiss = () => {
    setDismissed(true);
    onComplete?.();
  };

  return (
    <div className="absolute top-20 left-4 z-50 w-72 bg-slate-800 rounded-xl shadow-xl border border-slate-700 overflow-hidden animate-in slide-in-from-left duration-300">
      {/* Header */}
      <div className="bg-gradient-to-r from-blue-600 to-purple-600 px-4 py-3 text-white">
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-2">
            <Lightbulb className="w-4 h-4" />
            <span className="font-semibold text-sm">Getting Started</span>
          </div>
          <button
            onClick={handleDismiss}
            className="p-1 hover:bg-white/20 rounded transition-colors"
          >
            <X className="w-4 h-4" />
          </button>
        </div>
      </div>

      {/* Tips */}
      <div className="p-4 space-y-3">
        <div className="flex items-start gap-3">
          <div className="p-1.5 bg-blue-900/50 rounded-lg flex-shrink-0">
            <MousePointer2 className="w-3.5 h-3.5 text-blue-400" />
          </div>
          <p className="text-xs text-slate-300">
            <span className="font-medium">Add components</span> by clicking them in the dock below
          </p>
        </div>

        <div className="flex items-start gap-3">
          <div className="p-1.5 bg-purple-900/50 rounded-lg flex-shrink-0">
            <Link2 className="w-3.5 h-3.5 text-purple-400" />
          </div>
          <p className="text-xs text-slate-300">
            <span className="font-medium">Connect components</span> by dragging between the handles (dots)
          </p>
        </div>

        <div className="flex items-start gap-3">
          <div className="p-1.5 bg-emerald-900/50 rounded-lg flex-shrink-0">
            <Eye className="w-3.5 h-3.5 text-emerald-400" />
          </div>
          <p className="text-xs text-slate-300">
            <span className="font-medium">View Solution</span> to see a reference design and copy it to your canvas
          </p>
        </div>

        <div className="flex items-start gap-3">
          <div className="p-1.5 bg-amber-900/50 rounded-lg flex-shrink-0">
            <Sparkles className="w-3.5 h-3.5 text-amber-400" />
          </div>
          <p className="text-xs text-slate-300">
            <span className="font-medium">Submit</span> to get AI-powered feedback on your design
          </p>
        </div>
      </div>

      {/* Footer */}
      <div className="px-4 pb-4">
        <button
          onClick={handleDismiss}
          className="w-full py-2 bg-gradient-to-r from-blue-600 to-purple-600 text-white text-xs font-medium rounded-lg hover:shadow-md transition-all"
        >
          Got it!
        </button>
      </div>
    </div>
  );
};

export default TutorialOverlay;
